import { fetchIngredients } from '@/api'
import { Ingredient, SearchIngredient } from '@/api/types'
import { Spinner } from '@/components/Spinner'
import { CompactTable } from '@/components/Table'
import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onSelectionChange: ({ idIngredient, name }: { idIngredient: number; name: string }) => void
}

export default function IngredientSelector({ onSelectionChange }: Props) {
  const { t } = useTranslation()
  const { data = [], isLoading } = useQuery({
    queryKey: ['ingredients'],
    queryFn: () => fetchIngredients({}),
  })

  function handleSelectionChange(items: number[]) {
    if (items.length > 0) {
      const ingredient = data.find((r) => r.idIngredient === items[0])
      if (ingredient) {
        onSelectionChange({ idIngredient: ingredient.idIngredient, name: ingredient.name })
      }
    }
  }

  return (
    <div>
      {isLoading ? (
        <div style={{ minHeight: 400 }}>
          <Spinner />
        </div>
      ) : (
        <CompactTable
          aria-label="FCDB ingredients"
          selectionMode="single"
          onSelectionChange={(items) => handleSelectionChange([...items] as number[])}
          rowId="idIngredient"
          sorting
          search={{
            columns: ['name', 'englishName'],
          }}
          columns={[
            {
              key: 'idIngredient',
              label: 'ID',
              width: 100,
            },
            {
              key: 'name',
              label: t('ingredient.name'),
            },
            {
              key: 'englishName',
              label: t('ingredient.englishName'),
            },
          ]}
          rows={data}
        />
      )}
    </div>
  )
}
